module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-1.7999c103.png";